import axios from "../middlewares/axios";
import {AD_COMPANIES} from "../config/paths";

export async function getAdCompanies(limit, page, search, order, filters) {
    const data = {
        limit,
        page,
        with: {
            relationships: ["restaurants", "tariffs", "source"],
            properties: []
        },
    };
    
    if (order) {
        data.order = order;
    }
    
    const filtersList = [];
    
    const filtersGroup = {
        type: "group",
        group: [],
    };
    const searchGroup = {
        type: "group",
        group: [],
    };
    
    if (filters) {
        if (filters.restaurant && filters.restaurant.length > 0) {
            filtersGroup.group.push({
                column: "restaurants.id",
                operator: "=",
                value: filters.restaurant,
            });
        }
        if (filters.tariff && filters.tariff.length > 0) {
            filtersGroup.group.push({
                column: "tariffs.id",
                operator: "=",
                value: filters.tariff,
            });
        }
        
        filtersGroup.group.map((item, index) => {
            if (index !== 0) {
                item.boolean = "and";
            }
        });
        
        if (filtersGroup.group.length !== 0) {
            filtersList.push(filtersGroup);
        }
    }
    
    if (search) {
        const searchColumns = ["name", "utm_source"];
        searchColumns.map((column, index) => {
            const searchObject = {
                column,
                operator: "ilike",
                value: "%" + search + "%",
            };
            if (index !== 0) {
                searchObject.boolean = "or";
            }
            searchGroup.group.push(searchObject);
        });
        
        if (searchGroup.group.length !== 0) {
            filtersList.push(searchGroup);
        }
    }
    
    filtersList.map((item, index) => {
        if (index !== 0) {
            item.boolean = "and";
        }
    });
    
    if (filtersList.length !== 0) {
        data.filter = filtersList;
    }
    
    const response = await axios.post(AD_COMPANIES + "/search", data);
    return response.data;
}

export async function postAdCompany(data) {
    return await axios.post(AD_COMPANIES, {
        ...data,
    });
}

export async function putAdCompany(id, data) {
    return await axios.put(AD_COMPANIES + "/" + id, {
        ...data,
    });
}

export async function deleteAdCompany(id) {
    const response = await axios.delete(AD_COMPANIES + "/" + id);
    
    return response.data;
}
